import moment from "../../moment";

// API用の日付format変換
export const convertDateFormatForApi = (date) => {
  return moment(new Date(date)).format("YYYYMMDD");
};
